/**
 * PageFavorites JS controller.
 */

import Common from './common';

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Page
 */
export default class PageFavorites {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Favorites wrapper element.
        this.favoritesWrapper = $( '#js-favorites-wrapper' );

        // Favorites.
        this.favoritesHouses = $( '#js-favorites-houses' );

        // Remove from favorites links.
        this.removeFromFavorites = $( '.remove-from-favorites' );

        // Favorites count container in header.
        this.favoritesCountContainer = $( '#js-favorites-count-container' );

        // Favorites count number in header.
        this.favoritesCount = $( '#js-favorites-count-number' );

        // No favorites text.
        this.noFavoritesText = $( '#js-no-favorites-text' );

        // Spinner.
        this.spinner = $( '#js-page-favorites-spinner' );

        // Email form container.
        this.emailFormContainer = $( '#js-favorites-send-email-container' );

        // Send favorites to email button & text field.
        this.sendEmailButton = $( '#js-send-favorites-email-button' );
        this.sendEmailAddress = $( '#js-send-favorites-email-address' );

        // Success message.
        this.emailSent = $( '#js-favorites-email-sent' );
    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * All common events
     *
     * @return {void}
     */
    events() {

        /**
         * Remove house from favorites.
         */
        this.removeFromFavorites.on( 'click', ( e ) => {
            this.updateFavoritesList( e );
        });

        /**
         * Send email on click.
         */
        this.sendEmailButton.on( 'click', ( e ) => {
            this.sendFavoritesEmail( e );
        });
    }

    /**
     * Get favorited houses via AJAX on initial page load.
     *
     * @return {void}
     */
    getFavorites() {

        const ids = Common.getFavoritedHouses();

        // Show spinner.
        this.spinner.addClass( 'spinner--active' );

        dp( 'PageFavorites/FavoritedHouses', {
            partial: 'favorited-items',
            tidy: true,
            data: true,
            args: {
                /*eslint-disable */
               ajax_params_favorites: {
                   ids: ids,
               }
               /*eslint-enable */
           }
        }).then( ( response ) => {

                this.favoritesHouses.html( response.success );

                // Update 'remove from favorites' buttons variable.
                this.removeFromFavorites = $( '.remove-from-favorites' );

                // Add click event handler again to new buttons.
                this.removeFromFavorites.on( 'click', ( e ) => {
                    this.updateFavoritesList( e );
                });

                Common.showPrices();

                // Hide spinner.
                this.favoritesWrapper.removeClass( 'loading' );
                this.spinner.removeClass( 'spinner--active' );

                // Show email form container.
                this.emailFormContainer.removeClass( 'hidden' );
        }).catch( ( error ) => {
            console.log( error );
        });
    }

    /**
     * Replace favorites page content with updated houses list.
     *
     * @return {void}
     */
    updateFavoritesList( e ) {

        const buttons   = $( '.remove-from-favorites' );
        const allIds    = [];
        const removedId = e.target.getAttribute( 'data-id' );

        // Show spinner.
        this.favoritesWrapper.addClass( 'loading' );
        this.spinner.addClass( 'spinner--active' );

        // Remove cookie.
        Common.setCookie( 'hirsitalot-favorites[' + removedId + ']', removedId, 1 );

        buttons.each( function( key, value ) {
            const id = value.getAttribute( 'data-id' );
            allIds.push( id );
        });

        // Remove removedId from array.
        const ids = allIds.filter( id => id !== removedId );

        dp( 'PageFavorites/FavoritedHouses', {
            partial: 'favorited-items',
            tidy: true,
            data: true,
            args: {
                /*eslint-disable */
                ajax_params_favorites: {
                    ids: ids,
                }
                /*eslint-enable */
            }
        }).then( ( response ) => {
            this.favoritesHouses.html( response.success );

            // Update 'remove from favorites' buttons variable.
            this.removeFromFavorites = $( '.remove-from-favorites' );

            // Add click event handler again to new buttons.
            this.removeFromFavorites.on( 'click', ( e ) => {
                this.updateFavoritesList( e );
            });

            // Hide count number container if numer is 0.
            if ( response.data.posts.length === 0 ) {
                this.favoritesCountContainer.addClass( 'hidden' );
                this.noFavoritesText.removeClass( 'hidden' );
                this.emailFormContainer.addClass( 'hidden' );
            } else {
                this.favoritesCountContainer.removeClass( 'hidden' );
                this.favoritesCount.html( response.data.posts.length );
                this.emailFormContainer.removeClass( 'hidden' );
            }

            Common.showPrices();

            // Hide spinner.
            this.favoritesWrapper.removeClass( 'loading' );
            this.spinner.removeClass( 'spinner--active' );
        }).catch( ( error ) => {
            console.log( error );
        });
    }

    /**
     * Send favorites to user's email.
     */
    sendFavoritesEmail() {

        // Return if there's no email address.
        if ( this.sendEmailAddress.val() === '' ) {
            return;
        }

        const houseIds = [];

        const favorites = $( '.favorites-item' );

        favorites.each( ( index, favorite ) => {
            const houseId = favorite.getAttribute( 'data-id' );
            houseIds.push( houseId );
        });

        const address = this.sendEmailAddress.val();

        // Used to class this inside AJAX request's success.
        const thisClass = this;

        dp( 'PageFavorites/SendFavoritesEmail', {
            args: {
                /*eslint-disable */
                ajax_params_email: {
                    address: address,
                    houseIds: houseIds,
                }
                /*eslint-enable */
            }
        }).then( ( response ) => {

            // Empty email field and show success message.
            thisClass.sendEmailAddress.val( '' );
            thisClass.emailSent.removeClass( 'hidden' );
        }).catch( ( error ) => {
            console.log( error );
        });
    }

    /**
     * Run when the document is ready.
     *
     * @return {void}
     */
    docReady() {
        this.cache();
        this.events();
        this.getFavorites();
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/page-favorites.js